// extracted by mini-css-extract-plugin
module.exports = {"genericContent":"styles_genericContent__1ZGlY"};